/**
 * This method used to "resolve" images for the GatsbyImage component, but this
 * is no longer required. All we are doing is adding the width if provided by
 * options. This will be removed when nothing depends on the useImage hook.
 */
function getFluidImage(image: any, options?: { width?: number }) {
  if (options?.width) {
    return { ...image, width: options.width };
  }

  return image;
}

/**
 * @deprecated Use SanityImage or ShopifyImage directly.
 */
export const useImage = () => ({ getFluidImage });
